import React, { Component, Fragment } from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReactDatatable from '@ashvin27/react-datatable';
import { toastr } from "react-redux-toastr";
import { Modal } from "react-bootstrap";
import Spinner from 'react-bootstrap/Spinner';

import {
    GetCustumerUF, GetCustumerUFCid, GetCustumerEnd
    , GetCustumerVnd, getDataTdsRevendas, GetCustumerTodosCet
    , getDataDelivery, getDataFinancial, enviaRegistros
    //, teste
    // , getDataInformacoes
} from "./customerActions";
import { logout } from "./../../../auth/authActions";

import minhaImagemTodos from "../../../../src/figuras/exportar-todos.png";
import minhaImagemSelc from "../../../../src/figuras/exportar-selecinados.png";

class Customer extends Component {
    constructor(props) {
        super(props)

        this.state = {
            arrayMarcados: []
            , arrayEnviar: []
            , todosArrayEnviar: []

            , isModalOpen: 0
            , SelCodIni: 0, SelCodFim: 0
            , SelVnd: 0, SelUF: "", SelCidade: "", SelBairro: ""
            , SelPuxada: 0
            //           , booLerRecords: (this.props.codPuxada !== undefined && this.props.codPuxada !== null ? true : false)
            , LstCetSel: []
            , lstSelEnvCet: []
            , MsgModal2: ""

            // , intCtrlGrid: 0

        }

        if (this.props.codPuxada !== undefined && this.props.codPuxada !== null) {
            this.buscainformacoesFiltro(this.props.codPuxada);
        }
        else {
            this.props.getDataTdsRevendas();

        }

        this.columns = [

            {
                key: "action",
                text: "",
                className: "action",
                width: 30,
                align: "center",
                sortable: false,
                cell: (record, index) => {
                    return (
                        <Fragment>
                            <input
                                name="isGoing"
                                type="checkbox"
                                onClick={this.selecionaCheck.bind(this, record, index)}
                            >
                            </input >
                        </Fragment>
                    );
                }
            },

            {
                key: "action1",
                text: "",
                className: "action1",
                // width: 10,
                //align: "left",
                sortable: false,
                cell: (record, index) => {
                    return (
                        <Fragment>
                            <button variant="success"
                                name="isGoing"
                                type="button"
                                className="btn btn-outline-success btn-sm"
                                style={{ fontSize: "12px", fontFamily: "Barlow", fontStyle: "italic", fontWeight: "Bold" }}
                                onClick={this.chamaDelivery.bind(this, record, index)}
                                title="Informações do Delivery do Cliente"
                            > D
                            </button >
                        </Fragment >
                    );
                }
            },
            {
                key: "action2",
                text: "",
                className: "action2",
                // width: 10,
                //align: "left",
                sortable: false,
                cell: (record, index) => {
                    return (
                        <Fragment>
                            <button
                                name="isGoing1"
                                type="button"
                                className="btn btn-outline-success btn-sm"
                                style={{ fontSize: "12px", fontFamily: "Barlow", fontStyle: "italic", fontWeight: "Bold" }}
                                onClick={this.chamaFinancial.bind(this, record, index)}
                                title="Informações do Financial do Cliente"
                            > F
                            </button >
                        </Fragment>
                    );
                }
            },
            {
                key: "action3",
                text: " ",
                className: "action3",
                // width: 10,
                //align: "left",
                sortable: false,
                cell: (record, index) => {
                    return (
                        <Fragment>
                            <button
                                name="isGoing2"
                                type="button"
                                className="btn btn-outline-success btn-sm"
                                style={{ fontSize: "12px", fontFamily: "Barlow", fontStyle: "italic", fontWeight: "Bold" }}
                                onClick={this.chamaOutrasInformacoes.bind(this, record, index)}
                                title="Outras Informações do Cliente"
                            > I
                            </button >
                        </Fragment>
                    );
                }
            },

            {
                key: "resellerID",
                text: "ResellerID",
                className: "resellerID",
                align: "left",
                sortable: true
            },
            {
                key: "codcet",
                text: "CodCet",
                className: "codcet",
                align: "left",
                sortable: true,

            },
            {
                key: "name",
                text: "Name",
                className: "name",
                align: "left",
                sortable: true,
                width: 250,
                fontSize: "10px"
            },
            {
                key: "country",
                text: "Cuntry",
                className: "country",
                align: "left",
                sortable: true
            },
            {
                key: "state",
                text: "UF",
                className: "state",
                sortable: true,
                align: "left"
            },
            {
                key: "city",
                text: "City",
                className: "city",
                sortable: true,
                align: "left"
            },
            {
                key: "telephoneNumber",
                text: "Telephone",
                className: "telephoneNumber",
                sortable: true,
                align: "left"
            },
            {
                key: "emailAddress",
                text: "EmailAddress",
                className: "emailAddress",
                sortable: true,
                align: "left",
                width: 240
            },
            {
                key: "profile1",
                text: "Cod.",
                className: "profile1",
                sortable: true,
                align: "left"
            },
            {
                key: "profile11",
                text: "DscVnd",
                className: "profile11",
                sortable: true,
                align: "left",
                width: 240
            },
            // {
            //     key: "lastPaymentAmount",
            //     text: "LastPaymentAmount",
            //     className: "lastPaymentAmount",
            //     sortable: true,
            //     align: "left"
            // },
            // {
            //     key: "lastPaymentDate",
            //     text: "LastPaymentDate",
            //     className: "lastPaymentDate",
            //     sortable: true,
            //     align: "left"
            // },
            // {
            //     key: "nextPaymentAmount",
            //     text: "NextPaymentAmount",
            //     className: "nextPaymentAmount",
            //     sortable: true,
            //     align: "left"
            // },
            // {
            //     key: "nextPaymentDate",
            //     text: "NextPaymentDate",
            //     className: "nextPaymentDate",
            //     sortable: true,
            //     align: "left"
            // },

        ];

        this.config = {
            key_column: 'codcet',
            page_size: 10,
            length_menu: [10, 20, 50],
            button: {
                excel: true,
                print: true,
                extra: false,
            },
            filename: "Customer",

            language: {
                loading: "True",
                length_menu: "Mostrar _MENU_ registros por página",
                filter: "Buscar em registros ...",
                info: "Mostrando _START_ a _END_ de _TOTAL_ entradas",
                pagination: {
                    first: "Primeira",
                    previous: "Anterior",
                    next: "Próxima",
                    last: "Última"
                },
                loading_text: "Aguarde buscando informações..."
            }

        }


        this.chamaDelivery = this.chamaDelivery.bind(this);
        this.chamaFinancial = this.chamaFinancial.bind(this);
        this.chamaOutrasInformacoes = this.chamaOutrasInformacoes.bind(this);
        this.selecionaCheck = this.selecionaCheck.bind(this);

        this.SetCarreganaLista = this.SetCarreganaLista.bind(this);
        this.setCodCetIni = this.setCodCetIni.bind(this)
        this.setCodCetFim = this.setCodCetFim.bind(this);

        this.setVnd = this.setVnd.bind(this);
        this.setUF = this.setUF.bind(this);
        this.setCidade = this.setCidade.bind(this);
        this.setBairro = this.setBairro.bind(this);

        this.setAdcLstCodCet = this.setAdcLstCodCet.bind(this);
        this.setAdcLstVnd = this.setAdcLstVnd.bind(this);
        this.setAdcLstEnd = this.setAdcLstEnd.bind(this);

        this.setLimpaFiltro = this.setLimpaFiltro.bind(this);
        this.setEnviaFiltro = this.setEnviaFiltro.bind(this);

        this.OpenModalParam = this.OpenModalParam.bind(this);
        this.FecharModalParam = this.FecharModalParam.bind(this);

        this.setPuxada = this.setPuxada.bind(this);

        this.PopulartodosArrayEnviar = this.PopulartodosArrayEnviar.bind(this);
        this.ExportaSelecao = this.ExportaSelecao.bind(this);
        this.ExportaTodos = this.ExportaTodos.bind(this);
        //  this.SetReCarreganaLista = this.SetReCarreganaLista.bind(this);

    }

    setPuxada(e) {

        this.setState({
            SelPuxada: e.target.value
            ,booLerRecords: false
        });

        this.setLimpaFiltro();

        if (e.target.value === null || e.target.value === 0) {
            toastr.warning("Atenção Selecione uma Revenda")
        }
        else {
            this.buscainformacoesFiltro(e.target.value);
        }
    }

    selecionaCheck = (registro, record, index) => {

        const array1 = [];
        const array2 = [];
        let Existe = [{}];

        Existe = this.state.arrayMarcados
            .filter((a) => a.codcet === registro.codcet)

        if (Existe.length === 0) {
            this.state.arrayMarcados.push(registro)
            this.state.arrayEnviar.push(registro.codcet);
        }
        else {
            //Carrega Array1
            for (let i = 0, l = this.state.arrayMarcados.length; i < l; i++) {
                if (this.state.arrayMarcados[i].codcet !== registro.codcet) {
                    array1.push(this.state.arrayMarcados[i]);
                    array2.push(this.state.arrayMarcados[i].codcet);
                }
            }

            this.setState({
                arrayEnviar: array2
                , arrayMarcados: array1
            });

        }

    }

    ExportaSelecao(Opcao) {

        if (this.state.arrayEnviar.length === 0) {
            toastr.warning("Não há seleção realizada !!!!")
        }
        else {
            this.setState({
                MsgModal2: "Enviando a solicitação... Será realizado em fila processamentos"
            });
            this.openModal(5)
            this.props.enviaRegistros(this.state.arrayEnviar
                , (this.props.codPuxada === undefined || this.props.codPuxada === null
                    ? this.state.SelPuxada : this.props.codPuxada)
                , this.props.nomeUsuario, Opcao
            )
            setTimeout(() => {
                this.setState({
                    arrayMarcados: []
                    , arrayEnviar: []
                    //         , intCtrlGrid: 1
                    , lstSelEnvCet: []
                    //, isModalOpen: 1
                    , isModalOpen: 0
                });
            }, 4000);
        }

    }

    ExportaTodos(Opcao) {

        this.PopulartodosArrayEnviar();

        if (this.state.todosArrayEnviar.length === 0) {
            toastr.warning("Não há Custumers a enviar !!!!")
        }
        else {
            this.setState({
                MsgModal2: "Enviando a solicitação... Será realizado em fila processamentos"
            });
            this.openModal(5)
            this.props.enviaRegistros(this.state.todosArrayEnviar
                , (this.props.codPuxada === undefined || this.props.codPuxada === null
                    ? this.state.SelPuxada : this.props.codPuxada)
                , this.props.nomeUsuario, Opcao
            )
            setTimeout(() => {
                this.setState({
                    arrayMarcados: []
                    , arrayEnviar: []
                    //       , intCtrlGrid: 1
                    , lstSelEnvCet: []
                    // , isModalOpen: 1
                    , isModalOpen: 0
                });
            }, 4000);
        }
    }

    // SetReCarreganaLista() {
    // //     // const arraylstAtual = this.state.LstCetSel || [];
    // //     this.props.teste(this.state.LstCetSel || []);
    //      this.setState({
    //         intCtrlGrid: 0
    //      });
    //  }

    buscainformacoesFiltro(bifCodPuxada) {

        this.props.GetCustumerUF(bifCodPuxada);
        this.props.GetCustumerUFCid(bifCodPuxada);
        this.props.GetCustumerEnd(bifCodPuxada);
        this.props.GetCustumerVnd(bifCodPuxada);

    }

    openModal = (qualfiltro) => {
        this.setState({ isModalOpen: qualfiltro });
    }

    closeModal = () => this.setState({ isModalOpen: 0 })

    OpenModalParam(qualfiltro) {

        if (this.props.codPuxada === undefined || this.props.codPuxada === null) {
            if (Number(this.state.SelPuxada) === 0 | this.state.SelPuxada === undefined) {
                toastr.warning("Atenção não selecionou uma Revenda !!!")
            }
            else {
                if (qualfiltro === 1) {

                    this.props.GetCustumerTodosCet(
                        (this.props.codPuxada === undefined || this.props.codPuxada === null
                            ? this.state.SelPuxada : this.props.codPuxada) //CodPuxada
                        , 4                     //TipoBusca
                        , 0                     //CodVnd
                        , "null"                   //StrUF
                        , "null"                    //StrCdd
                        , "null"                    //StrBairro
                        , 0                     //CodCetIni
                        , 0                     //CodCetFim
                        , false                 //OpcSOmenteUm
                    ,);


                }
                this.openModal(qualfiltro);
            }
        }
        else {
            if (qualfiltro === 1) {

                this.props.GetCustumerTodosCet(
                    (this.props.codPuxada === undefined || this.props.codPuxada === null
                        ? this.state.SelPuxada : this.props.codPuxada) //CodPuxada
                    , 4                     //TipoBusca
                    , 0                     //CodVnd
                    , "null"                    //StrUF
                    , "null"                     //StrCdd
                    , "null"                     //StrBairro
                    , 0                     //CodCetIni
                    , 0                     //CodCetFim
                    , false                 //OpcSOmenteUm
                                    ,);


            }
            this.openModal(qualfiltro);
        };

    }

    FecharModalParam() {
        this.closeModal();
    }

    chamaDelivery = (registro, record, index) => {
        this.props.getDataDelivery(
            (this.props.codPuxada === undefined || this.props.codPuxada === null
                ? this.state.SelPuxada : this.props.codPuxada)
            , registro.resellerID
            , registro.codcet);
        this.OpenModalParam(2);
    }

    chamaFinancial = (registro, record, index) => {
        this.props.getDataFinancial(
            (this.props.codPuxada === undefined || this.props.codPuxada === null
                ? this.state.SelPuxada : this.props.codPuxada)
            , registro.resellerID
            , registro.codcet);
        this.OpenModalParam(3);
    }

    chamaOutrasInformacoes = (registro, record, index) => {

        this.props.GetCustumerTodosCet(
            (this.props.codPuxada === undefined || this.props.codPuxada === null
                ? this.state.SelPuxada : this.props.codPuxada) //CodPuxada
            , 3                     //TipoBusca
            , 0                     //CodVnd
            , "null"                    //StrUF
            , "null"                    //StrCdd
            ,"null"                     //StrBairro
            , registro.codcet       //CodCetIni
            , registro.codcet       //CodCetFim
            , true                  // OpcSOmenteUm
                    ,);
        this.OpenModalParam(4);
    }

    setLimpaFiltro() {

        this.setState({
            LstCetSel: []
            , SelCodIni: 0
            , SelCodFim: 0
            , SelVnd: 0
            , SelUF: ""
            , SelCidade: ""
            , SelBairro: ""
            , todosArrayEnviar: []
            , arrayEnviar: []
            , arrayMarcados: []

        });
    }

    setEnviaFiltro() {

        this.setState({
            lstSelEnvCet: this.state.LstCetSel || []
        });
        this.FecharModalParam();
    }
    setCodCetIni(e) {
        this.setState({
            SelCodIni: e.target.value
            , SelCodFim: (this.state.SelCodFim === undefined || this.state.SelCodFim === 0 ? e.target.value : this.state.SelCodFim)
        });
    }
    setCodCetFim(e) {
        this.setState({
            SelCodFim: e.target.value
        });
    }
    setVnd(e) {
        this.setState({
            SelVnd: e.target.value
        });
    }
    setUF(e) {
        this.setState({
            SelUF: e.target.value
        });

    }
    setCidade(e) {
        this.setState({
            SelCidade: e.target.value
        });
    }
    setBairro(e) {
        this.setState({
            SelBairro: e.target.value
        });
    }

    setAdcLstCodCet() {
        let booPodeTrazer = true;

        if (Number.isInteger(Number.parseInt(this.state.SelCodIni)) === false) {
            toastr.warning("Atenção Código do Cliente inicial não é Numerico");
            booPodeTrazer = false;
        }
        if (Number.isInteger(Number.parseInt(this.state.SelCodFim)) === false && booPodeTrazer === true) {
            toastr.warning("Atenção Código do Cliente final não é Numerico");
            booPodeTrazer = false;
        }
        if ((this.state.SelCodFim === 0 || this.state.SelCodIni === 0) && booPodeTrazer === true) {
            toastr.warning("Atenção Código Final = 0 or Código Inicial = 0 ")
            booPodeTrazer = false;
        }

        if (this.state.SelCodFim < this.state.SelCodIni && booPodeTrazer === true) {
            toastr.warning("Atenção Código Final menor que o Código Inicial")
            booPodeTrazer = false;
        }
        if (booPodeTrazer === true) {
            // this.props.GetCustumerTodosCet(
            //     (this.props.codPuxada === undefined || this.props.codPuxada === null
            //         ? this.state.SelPuxada : this.props.codPuxada) //CodPuxada
            //     , 3                     //TipoBusca
            //     , 0                     //CodVnd
            //     , ''                    //StrUF
            //     , ''                    //StrCdd
            //     , ''                    //StrBairro
            //     , this.state.SelCodIni   //CodCetIni
            //     , this.state.SelCodFim   //CodCetFim
            //     , false                 // OpcSOmenteUm
            // ,);
            this.SetCarreganaLista(
                3                     //TipoBusca
                , 0                     //CodVnd
                , ''                    //StrUF
                , ''                    //StrCdd
                , ''                    //StrBairro
                , this.state.SelCodIni   //CodCetIni
                , this.state.SelCodFim   //CodCetFim
            );
        }


    }
    setAdcLstEnd() {
        if (this.state.SelUF === "" || this.state.SelUF === undefined) {
            toastr.warning("UF não selecionada")
        }
        // else {
        //     if (this.state.SelCidade === "" || this.state.SelCidade === undefined) {
        //         toastr.warning("Cidade não selecionada")
        //     }
        //     else {
        //         if (this.state.SelBairro === "" || this.state.SelBairro === undefined) {
        //             toastr.warning("Bairro não selecionado")
        //         }
        else {
            // this.props.GetCustumerTodosCet(
            //     (this.props.codPuxada === undefined || this.props.codPuxada === null
            //         ? this.state.SelPuxada : this.props.codPuxada) //CodPuxada
            //     , 2                     //TipoBusca
            //     , 0                     //CodVnd
            //     , this.state.SelUF      //StrUF
            //     , this.state.SelCidade  //StrCdd
            //     , this.state.SelBairro  //StrBairro
            //     , 0                      //CodCetIni
            //     , 0                      //CodCetFim
            //     , false                 // OpcSOmenteUm
            //     ,);
            this.SetCarreganaLista(
                2                     //TipoBusca
                , 0                     //CodVnd
                , this.state.SelUF      //StrUF
                , this.state.SelCidade  //StrCdd
                , this.state.SelBairro  //StrBairro
                , 0                      //CodCetIni
                , 0                      //CodCetFim
            );

        }

        // }
        // }
    }
    setAdcLstVnd() {
        if (this.state.SelVnd === 0
            || this.state.SelVnd === undefined
            || this.state.SelVnd === -1) {
            toastr.warning("Vendedor não selecionado");
        }
        else {
            // this.props.GetCustumerTodosCet(
            //     (this.props.codPuxada === undefined || this.props.codPuxada === null
            //         ? this.state.SelPuxada : this.props.codPuxada) //CodPuxada
            //     , 1                     //TipoBusca
            //     , this.state.SelVnd     //CodVnd
            //     , ''                    //StrUF
            //     , ''                    //StrCdd
            //     , ''                    //StrBairro
            //     , 0                      //CodCetIni
            //     , 0                      //CodCetFim
            //     , false                 // OpcSOmenteUm
            //     ,);
            this.SetCarreganaLista(
                1                       //TipoBusca
                , this.state.SelVnd     //CodVnd
                , ''                    //StrUF
                , ''                    //StrCdd
                , ''                    //StrBairro
                , 0                      //CodCetIni
                , 0                      //CodCetFim
            );
        }
    }

    SetCarreganaLista(TipoBusca, CodVnd, StrUF, StrCdd, StrBairro, CodCetIni, CodCetFim) {

        const arraylstAtual = this.state.LstCetSel || [];
        const arraylstTodosClientes = this.props.bsclistaTodosCet || [];

        let arraylstDoFiltro = [];

        //Carrega com o Filtro
        if (TipoBusca === 1) {
            arraylstDoFiltro = arraylstTodosClientes
                .filter((a) => Number(a.profile1) === Number(CodVnd))
        }
        if (TipoBusca === 2) {
            if (StrCdd === "" && StrBairro === "") {
                arraylstDoFiltro = arraylstTodosClientes
                    .filter((a) => a.state === StrUF)
            }
            else
                if (StrBairro === "" && StrCdd !== "") {
                    arraylstDoFiltro = arraylstTodosClientes
                        .filter((a) => a.state === StrUF && a.city === StrCdd)
                }
                else {
                    arraylstDoFiltro = arraylstTodosClientes
                        .filter((a) => a.state === StrUF && a.city === StrCdd && a.suburb === StrBairro)
                }
        }

        if (TipoBusca === 3) {
            arraylstDoFiltro = arraylstTodosClientes
                .filter((a) => a.codcet >= CodCetIni && a.codcet <= CodCetFim)

        }

        //Carrega arraylstAtual
        for (let i = 0, l = arraylstDoFiltro.length; i < l; i++) {

            let Existe = []

            Existe =
                (
                    arraylstAtual.filter((a) => a.codcet === arraylstDoFiltro[i].codcet)
                )

            if (Existe.length === 0) {
                arraylstAtual.push(arraylstDoFiltro[i])
            }

        }

        this.setState({
            LstCetSel: arraylstAtual
        });

    }

    PopulartodosArrayEnviar() {

        this.setState({ todosArrayEnviar: [] });

        if (this.state.lstSelEnvCet !== undefined && this.state.lstSelEnvCet !== null) {
            for (let i = 0, l = this.state.lstSelEnvCet.length; i < l; i++) {
                this.state.todosArrayEnviar.push(this.state.lstSelEnvCet[i].codcet);
            }
        }

    }

    render() {
        const listaTdsUF = this.props.bsclistaTdsUF || [];
        const listaTdsUFCid = this.props.bsclistaTdsUFCid || [];
        const listaTdsEnd = this.props.bsclistaTdsEnd || [];
        const listaTdsVnd = this.props.bsclistaTdsVnd || [];
        const Listapuxadas = this.props.redListaTdsRevendas || [];

        const RegDelivery = this.props.BscDelivery || [];
        const RegFinancial = this.props.BscFinancial || [];
        const RegInformacoes = this.props.BscInformacoes || [];

        return (


            <div className="container" >

                <div className="row">
                    <div className="Col">
                        <span className="cadastro-Externos">Inicial / &nbsp;
                            <span className="text-style-1">Customer</span>
                        </span>
                    </div>
                    <br />
                    <br />
                </div>

                <div className="row" style={{
                    display: (this.props.codPuxada === undefined || this.props.codPuxada === null ? "flex" : "none")
                    , fontSize: "18px", color: "#77b935", fontFamily: "Barlow"
                }}>
                    <div className="col">
                        <select id="Revenda"
                            value={this.state.SelPuxada}
                            onChange={this.setPuxada}
                        >
                            <option value="0">-- Selecione Revenda --</option>
                            {Listapuxadas
                                .map((ar, i) => (
                                    <option key={i} value={ar.cod_puxada}>
                                        {ar.cod_puxada + " - " + ar.dsc_razaosocial}
                                    </option>
                                ))}
                        </select>
                    </div>
                    <br />
                    <br />
                </div>

                <div className="row"
                    style={{
                        display: (this.props.codPuxada !== undefined && this.props.codPuxada !== null ? "flex" : "none")
                        , fontSize: "12px", color: "#77b935"
                    }}>
                    <div className="Col">
                        <span className="cadastro-Externos1">&nbsp;
                            <span>Código da Revenda: &nbsp; {(this.props.codPuxada === undefined || this.props.codPuxada === null ? 0 : this.props.codPuxada)}</span>
                        </span>
                    </div>
                    <br />
                    <br />
                </div>

                <div className="form-control">
                    <div className="row">
                        <div className="col-md-4" >
                            <button type="button"
                                style={{ fontSize: "18px", backgroundColor: "#e8f7d5", border: "0" }}
                                data-toggle="tooltip"
                                title="Busca Informações para Filtro do Grid"
                                onClick={() => { this.OpenModalParam(1) }}
                            >
                                <i className="fa fa-filter " aria-hidden="true"></i>
                            </button>
                            <label style={{ color: "#77b935" }}> &nbsp; &nbsp;Informe os Filtros </label>
                        </div>
                        {/* <div className="col-md-6">
                            <input type="textarea" className="form-control"
                                //value={this.state.senha}
                                //onChange={this.setSenha}
                                //value={"xxxxx xxxxxxxxxx xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx xxxxxxxxxx  xxxxxxxxxx  xxxxxxxxxx  xxxxxxxxxx  xxxxxxxxxx  xxxxxxxxxx  xxxxxxxxxx  xxxxxxxxxx "}
                                style={{ fontSize: "12px", color: "#36561e" }}
                                defaultValue={"Informe Filtros para o Grid"}
                                readonly="true"
                                with="100%"
                            />
                        </div> */}
                        {/* <div className="col-md-2">
                            <button type="button"
                                style={{ fontSize: "18px", color: "#36561e" }}
                                data-toggle="tooltip"
                                title="Preenche Grid"
                            >
                                <i className="fa fa-refresh " aria-hidden="true"></i>
                            </button>
                        </div> */}
                    </div>
                </div>
                <br />

                <div className="form-control">
                    <div className="row">
                        <div className="col-md-4" style={{ color: "#77b935" }}>
                            Envia Customer
                            &nbsp;&nbsp;
                            <button type="button"
                                style={{ fontSize: "16px", backgroundColor: '#e8f7d5', border: "0" }}
                                data-toggle="tooltip"
                                title="Envia Customer Selecionados no Grid, vai junto Financial e Delivery"
                                onClick={() => { this.ExportaSelecao(1) }}
                            >
                                <img src={minhaImagemSelc} alt="" ></img>
                            </button>
                            &nbsp;&nbsp;
                            &nbsp;&nbsp;
                            <button type="button"
                                style={{ fontSize: "16px", backgroundColor: "#e8f7d5", border: "0" }}
                                data-toggle="tooltip"
                                title="Envia Todos Customer do Grid, vai junto Financial e Delivery"
                                onClick={() => { this.ExportaTodos(1) }}

                            >
                                <img src={minhaImagemTodos} alt="" ></img>
                            </button>
                        </div>
                        <div className="col-md-4" style={{ color: "#77b935" }}>
                            Envia Financial
                            &nbsp;&nbsp;
                            <button type="button"
                                style={{ fontSize: "16px", backgroundColor: "#e8f7d5", border: "0" }}
                                data-toggle="tooltip"
                                title="Envia Somente Financial Selecionados no Grid"
                                onClick={() => { this.ExportaSelecao(2) }}
                            >
                                <img src={minhaImagemSelc} alt="" ></img>
                            </button>
                            &nbsp;&nbsp;
                            &nbsp;&nbsp;
                            <button type="button"
                                style={{ fontSize: "16px", backgroundColor: "#e8f7d5", border: "0" }}
                                data-toggle="tooltip"
                                title="Envia Somente Todos Financial do Grid"
                                onClick={() => { this.ExportaTodos(2) }}
                            >
                                <img src={minhaImagemTodos} alt="" ></img>
                            </button>
                        </div>

                        <div className="col-md-4" style={{ color: "#77b935" }}>
                            Envia Delivery
                            &nbsp;&nbsp;
                            <button type="button"
                                style={{ fontSize: "16px", backgroundColor: "#e8f7d5", border: "0" }}
                                data-toggle="tooltip"
                                title="Envia Somente Delivery Selecionados no Grid"
                                onClick={() => { this.ExportaSelecao(3) }}
                            >
                                <img src={minhaImagemSelc} alt="" ></img>
                            </button>
                            &nbsp;&nbsp;
                            &nbsp;&nbsp;
                            <button type="button"
                                style={{ fontSize: "16px", backgroundColor: "#e8f7d5", border: "0" }}
                                data-toggle="tooltip"
                                title="Envia Somente Todos Delivery do Grid"
                                onClick={() => { this.ExportaTodos(3) }}
                            >
                                <img src={minhaImagemTodos} alt="" ></img>
                            </button>
                        </div>
                    </div>
                </div>

                <br />
                <div>
                    <ReactDatatable
                        config={this.config}
                        //                        records={(this.state.intCtrlGrid === 0 ? this.state.lstSelEnvCet : this.props.RefazCampo)}
                        records={this.state.lstSelEnvCet}
                        columns={this.columns}

                    //extraButtons={this.extraButtons}
                    />
                </div>

                {/* Filtro */}
                <Modal size="lg" show={(this.state.isModalOpen === 1 ? true : false)}
                    onHide={this.closeModal}
                >
                    <Modal.Header>
                        <Modal.Title
                            style={{
                                color: "#77b935"
                                , fontFamily: "Barlow"
                                , fontSize: "18px"
                                , fontStyle: "Italic"
                            }}
                        >Informaçoes do Filtro para o Grid Custumers
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <button type="button"
                                style={{ background: "#77b935" }}
                                className="btn btn-secondary"
                                onClick={this.setLimpaFiltro}
                            >Limpa Filtros
                            </button>

                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <button type="button"
                                style={{ background: "#77b935" }}
                                className="btn btn-secondary"
                                onClick={this.setEnviaFiltro}
                            >Envia Filtro
                            </button>

                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <button type="button"
                                style={{ background: "#77b935" }}
                                className="btn btn-secondary"
                                onClick={this.FecharModalParam}
                            >Cancela
                            </button>


                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="form-control">
                            <label style={{ color: "#77b935" }}>Código do Cliente </label>
                            <div className="row" >
                                <div className="col-md-4">
                                    <input type="text" id="CodCetIni" className="form-control"
                                        style={{ textAlign: "right" }}
                                        value={(this.state.SelCodIni)}
                                        onChange={this.setCodCetIni}
                                        placeholder="Inicial" maxLength="10" />
                                </div>
                                <div className="col-md-4">
                                    <input type="text" className="form-control"
                                        style={{ textAlign: "right" }}
                                        value={(this.state.SelCodFim === 0 ? this.state.SelCodIni : this.state.SelCodFim)}
                                        onChange={this.setCodCetFim}
                                        placeholder="Final" maxLength="10" />
                                </div>
                                <div className="col-md-2">
                                </div>
                                <div className="col-md-2">
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <button type="button"
                                        style={{ paddingRight: "true", fontSize: "18px", color: "#36561e" }}
                                        data-toggle="tooltip"
                                        title="Adiciona a Lista"
                                        onClick={this.setAdcLstCodCet}
                                    >
                                        <i className="fa fa-refresh " aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>

                            {/* </div> */}

                            {/* <div className="form-control"> */}
                            <div className="row" >
                                <div className="col-md-2">
                                    <label style={{ color: "#77b935" }}>UF</label>
                                </div>
                                <div className="col-md-4">
                                    <label style={{ color: "#77b935" }}>Cidade</label>
                                </div>
                                <div className="col-md-4">
                                    <label style={{ color: "#77b935" }}>Bairro</label>
                                </div>
                            </div>
                            <div className="row" >
                                <div className="col-md-2">
                                    <select id="UF"
                                        value={this.state.SelUF}
                                        onChange={this.setUF}
                                    >
                                        <option value="">-- UF --</option>
                                        {listaTdsUF
                                            .map((ar, i) => (
                                                <option key={i} value={ar.state}>
                                                    {ar.state}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                                <div className="col-md-4">
                                    <select id="Cidade"
                                        value={this.state.SelCidade}
                                        onChange={this.setCidade}
                                    >
                                        <option value="">-- Cidade --</option>
                                        {listaTdsUFCid
                                            .filter((a) => a.state === this.state.SelUF)
                                            .map((ar, i) => (
                                                <option key={i} value={ar.city}>
                                                    {ar.city}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                                <div className="col-md-4">
                                    <select id="Bairro"
                                        value={this.state.SelBairro}
                                        onChange={this.setBairro}
                                    >
                                        <option value="">-- Bairro --</option>
                                        {listaTdsEnd
                                            .filter((a) => a.state === this.state.SelUF
                                                && a.city === this.state.SelCidade)
                                            .map((ar, i) => (
                                                <option key={i} value={ar.suburb}>
                                                    {ar.suburb}
                                                </option>
                                            ))}
                                    </select>
                                </div>

                                <div className="col-md-2">
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <button type="button"
                                        style={{ fontSize: "18px", color: "#36561e" }}
                                        data-toggle="tooltip"
                                        title="Adiciona a Lista"
                                        onClick={this.setAdcLstEnd}

                                    >
                                        <i className="fa fa-refresh " aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>
                            {/* </div> */}

                            {/* <div className="form-control"> */}
                            <label style={{ color: "#77b935" }}>Vendedor </label>
                            <div className="row" >
                                <div className="col-md-10">
                                    <select id="Vendedores"
                                        value={(this.state.SelVnd)}
                                        onChange={this.setVnd}
                                    >
                                        <option value="0">-- Selecione um Vendedor --</option>
                                        {listaTdsVnd
                                            .map((ar, i) => (
                                                <option key={i} value={ar.profile1}>
                                                    {ar.profile1 + " - " + ar.profile11}
                                                </option>
                                            ))}
                                    </select>

                                </div>
                                <div className="col-md-2">
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <button type="button"
                                        style={{ fontSize: "18px", color: "#36561e" }}
                                        data-toggle="tooltip"
                                        title="Adiciona a Lista"
                                        onClick={this.setAdcLstVnd}
                                    >
                                        <i className="fa fa-refresh " aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="form-control">
                            {/* <div className="table-wrapper-scroll-y my-custom-scrollbar" */}
                            <div className="table "
                                style={{
                                    fontFamily: "Barlow", fontSize: "12px",
                                    color: "#36561e", height: "300px", overflow: "auto"
                                }}>

                                <table className="table table-bordered table-hover table-striped "
                                >
                                    <thead className="thead">
                                        <tr >
                                            <th>Código</th>
                                            <th>Descrição</th>
                                        </tr>
                                    </thead>
                                    <tbody className="tbody">
                                        {
                                            this.state.LstCetSel.map((item, i) => {
                                                return (
                                                    <tr key={i}>
                                                        <td>{item.codcet}</td>
                                                        <td>{item.name}</td>
                                                    </tr>
                                                )
                                            })
                                        }

                                    </tbody>

                                </table>
                            </div>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>


                    </Modal.Footer>

                </Modal>

                {/* Delivery */}
                <Modal size="xl" show={(this.state.isModalOpen === 2 ? true : false)}
                    className="modal fade" role="dialog"
                    onHide={this.closeModal}
                >
                    {/* <div className="modal-dialog modal-dialog-scrollable" role="document"> */}
                    {/* <div class="modal-content"> */}
                    <Modal.Header>
                        <Modal.Title
                            style={{
                                color: "#77b935"
                                , fontFamily: "Barlow"
                                , fontSize: "18px"
                                , fontStyle: "Italic"
                            }}
                        >Informações Delivery
                        </Modal.Title>

                        <button type="button"
                            style={{ background: "#77b935" }}
                            className="btn btn-secondary"
                            onClick={this.FecharModalParam}
                        >Retorna
                        </button>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="form-control">
                            {/* <div className="table-wrapper-scroll-y my-custom-scrollbar" */}
                            <table className="table table-bordered  table-striped table-sm "
                                cellspacing="0" width="100%"
                                style={{
                                    fontFamily: "Barlow", fontSize: "10px",
                                    color: "#36561e", height: "100px"

                                }}
                            >
                                <thead className="thead">
                                    <tr >
                                        {/* <th>resellerID</th> */}
                                        <th>codcet</th>
                                        <th>deliveryDay</th>
                                        <th>deliveryDate01</th>
                                        <th>cutOffDate01</th>
                                        <th>deliveryDate02</th>
                                        <th>cutOffDate02</th>
                                        <th>deliveryDate03</th>
                                        <th>cutOffDate03</th>
                                        <th>createdAtStaging</th>
                                        <th>updatedAtStaging</th>
                                        <th>sendToHybrisStatus</th>
                                        <th>sendDataHybris</th>
                                    </tr>
                                </thead>
                                <tbody className="tbody">
                                    {(RegDelivery.length === 0 ? <span> <br /><br />  &nbsp;&nbsp; &nbsp;&nbsp; "Não há Dados"</span>
                                        :
                                        RegDelivery.map((item, i) => {
                                            return (
                                                <tr key={i}>
                                                    {/* <td>{item.resellerID}</td> */}
                                                    <td>{item.codcet}</td>
                                                    <td>{item.deliveryDay}</td>
                                                    <td>{item.deliveryDate01}</td>
                                                    <td>{item.cutOffDate01}</td>
                                                    <td>{item.deliveryDate02}</td>
                                                    <td>{item.cutOffDate02}</td>
                                                    <td>{item.deliveryDate03}</td>
                                                    <td>{item.cutOffDate03}</td>
                                                    <td>{item.createdAtStaging}</td>
                                                    <td>{item.updatedAtStaging}</td>
                                                    <td>{item.sendToHybrisStatus}</td>
                                                    <td>{item.sendDataHybris}</td>
                                                </tr>
                                            )
                                        })
                                    )
                                    }

                                </tbody>

                            </table>

                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                    </Modal.Footer>
                    {/* </div> */}
                    {/* </div> */}
                </Modal>

                {/* Financial */}
                <Modal size="xl" show={(this.state.isModalOpen === 3 ? true : false)}
                    className="modal fade" role="dialog"
                    onHide={this.closeModal}
                >
                    <Modal.Header>
                        <Modal.Title
                            style={{
                                color: "#77b935"
                                , fontFamily: "Barlow"
                                , fontSize: "18px"
                                , fontStyle: "Italic"
                            }}
                        >Informações Financial
                        </Modal.Title>

                        <button type="button"
                            style={{ background: "#77b935" }}
                            className="btn btn-secondary"
                            onClick={this.FecharModalParam}
                        >Retorna
                        </button>

                    </Modal.Header>
                    <Modal.Body>
                        <div className="form-control">
                            <table className="table table-bordered  table-striped table-sm "
                                cellspacing="0" width="100%"
                                style={{
                                    fontFamily: "Barlow", fontSize: "12px",
                                    color: "#36561e", height: "200px"

                                }}
                            >
                                <thead className="thead">
                                    <tr >
                                        {/* <th>resellerID</th> */}
                                        <th>codcet</th>
                                        <th>idTitulo</th>
                                        <th>date</th>
                                        <th>amount</th>
                                        <th>type</th>
                                        <th>status</th>
                                        <th>expirationDate</th>
                                        <th>backendOrderId</th>
                                        <th>createdAtStaging</th>
                                        <th>updatedAtStaging</th>
                                        <th>sendToHybrisStatus</th>
                                        <th>sendDataHybris</th>
                                    </tr>
                                </thead>
                                <tbody className="tbody">
                                    {(RegFinancial.length === 0 ? <span> <br /><br /><br />  &nbsp;&nbsp; &nbsp;&nbsp; "Não há Dados"</span>
                                        :
                                        RegFinancial.map((item, i) => {
                                            return (
                                                <tr key={i}>
                                                    {/* <td>{item.resellerID}</td> */}
                                                    <td>{item.id}</td>
                                                    <td>{item.idTitulo}</td>
                                                    <td>{item.date}</td>
                                                    <td>{item.amount}</td>
                                                    <td>{item.type}</td>
                                                    <td>{item.status}</td>
                                                    <td>{item.expirationDate}</td>
                                                    <td>{item.backendOrderId}</td>
                                                    <td>{item.createdAtStaging}</td>
                                                    <td>{item.updatedAtStaging}</td>
                                                    <td>{item.sendToHybrisStatus}</td>
                                                    <td>{item.sendDataHybris}</td>
                                                </tr>
                                            )
                                        })
                                    )
                                    }

                                </tbody>

                            </table>

                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                    </Modal.Footer>
                </Modal>

                {/* Informações */}
                <Modal size="xl" show={(this.state.isModalOpen === 4 ? true : false)}
                    onHide={this.closeModal}
                >
                    <Modal.Header>
                        <Modal.Title
                            style={{
                                color: "#77b935", fontFamily: "Barlow"
                                , fontSize: "18px", fontStyle: "Italic"
                            }}>Outras Informações
                        </Modal.Title>
                        <button type="button"
                            style={{ background: "#77b935" }}
                            className="btn btn-secondary"
                            onClick={this.FecharModalParam}
                        >Retorna
                        </button>
                    </Modal.Header>

                    <Modal.Body>
                        <div className="form-control"
                            style={{ fontFamily: "Barlow", fontSize: "14px", color: "#36561e" }}
                        >
                            {
                                RegInformacoes.map((item, i) => {
                                    return (
                                        // <tr key={i}>
                                        <div class="container">
                                            <div class="row">
                                                <div class="col" >
                                                    <spam style={{ color: "#36561e" }} >Código Cliente:&nbsp; </spam>
                                                    <spam style={{ color: "#77b935" }} >  {item.codcet}</spam>
                                                </div>
                                                <div class="col" >
                                                </div>
                                                <div class="col">
                                                    <spam style={{ color: "#36561e" }} > Id:&nbsp;  </spam>
                                                    <spam style={{ color: "#77b935" }} >     {item.id}</spam>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col">
                                                    <spam style={{ color: "#36561e" }} >Name:&nbsp; </spam>
                                                    <spam style={{ color: "#77b935" }} >     {item.name} </spam>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col">
                                                    <spam style={{ color: "#36561e" }} > CustomerProductListId:&nbsp; </spam>
                                                    <spam style={{ color: "#77b935" }} >  {item.customerProductListId}</spam>
                                                </div>
                                                <div class="col" >
                                                </div>
                                                <div class="col">
                                                    <spam style={{ color: "#36561e" }} >  UsualProductListID:&nbsp; </spam>
                                                    <spam style={{ color: "#77b935" }} >    {item.usualProductListID}</spam>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col">
                                                    <spam style={{ color: "#36561e" }} > CentralBlock:&nbsp; </spam>
                                                    <spam style={{ color: "#77b935" }} >  {item.centralBlock}</spam>
                                                </div>
                                                <div class="col">
                                                    <spam style={{ color: "#36561e" }} >  DeliveryBlock:&nbsp; </spam>
                                                    <spam style={{ color: "#77b935" }} >  {item.deliveryBlock}</spam>
                                                </div>
                                                <div class="col">
                                                    <spam style={{ color: "#36561e" }} >  InvoiceBlock:&nbsp;</spam>
                                                    <spam style={{ color: "#77b935" }} >    {item.invoiceBlock}</spam>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div class="col">
                                                    <spam style={{ color: "#36561e" }} >  TotalBalancePastDue:&nbsp; </spam>
                                                    <spam style={{ color: "#77b935" }} >   {item.totalBalancePastDue}</spam>
                                                </div>
                                                <div class="col">
                                                    <spam style={{ color: "#36561e" }} >  TotalBalanceDue:&nbsp; </spam>
                                                    <spam style={{ color: "#77b935" }} >   {item.totalBalanceDue} </spam>
                                                </div>
                                                <div class="col">
                                                    <spam style={{ color: "#36561e" }} >   TotalBalance:&nbsp; </spam>
                                                    <spam style={{ color: "#77b935" }} >   {item.totalBalance}</spam>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div class="col">
                                                    <spam style={{ color: "#36561e" }} >  LastPaymentAmount:&nbsp; </spam>
                                                    <spam style={{ color: "#77b935" }} >   {item.lastPaymentAmount}</spam>
                                                </div>
                                                <div class="col" >
                                                </div>
                                                <div class="col">
                                                    <spam style={{ color: "#36561e" }} >  LastPaymentDate:&nbsp; </spam>
                                                    <spam style={{ color: "#77b935" }} >   {item.lastPaymentDate}</spam>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div class="col">
                                                    <spam style={{ color: "#36561e" }} >  NextPaymentAmount:&nbsp;</spam>
                                                    <spam style={{ color: "#77b935" }} >    {item.nextPaymentAmount}</spam>
                                                </div>
                                                <div class="col" >
                                                </div>
                                                <div class="col">
                                                    <spam style={{ color: "#36561e" }} > NextPaymentDate:&nbsp; </spam>
                                                    <spam style={{ color: "#77b935" }} >   {item.nextPaymentDate}</spam>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div class="col">
                                                    <spam style={{ color: "#36561e" }} >  CreditLimit:&nbsp; </spam>
                                                    <spam style={{ color: "#77b935" }} >   {item.creditLimit}</spam>
                                                </div>
                                                <div class="col">
                                                    <spam style={{ color: "#36561e" }} >   CreditExposure:&nbsp; </spam>
                                                    <spam style={{ color: "#77b935" }} >  {item.creditExposure}</spam>
                                                </div>
                                                <div class="col">
                                                    <spam style={{ color: "#36561e" }} >  CreditLimitUsed:&nbsp; </spam>
                                                    <spam style={{ color: "#77b935" }} >   {item.creditLimitUsed}</spam>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div class="col">
                                                    <spam style={{ color: "#36561e" }} >   MinimumOrderValue:&nbsp; </spam>
                                                    <spam style={{ color: "#77b935" }} >   {item.minimumOrderValue}</spam>
                                                </div>
                                                <div class="col">
                                                    <spam style={{ color: "#36561e" }} >  MaximumOrderValue:&nbsp; </spam>
                                                    <spam style={{ color: "#77b935" }} >   {item.maximumOrderValue}</spam>
                                                </div>
                                                <div class="col">
                                                    <spam style={{ color: "#36561e" }} >  FreeFlexibleDeliveryValue:&nbsp; </spam>
                                                    <spam style={{ color: "#77b935" }} >   {item.freeFlexibleDeliveryValue}</spam>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div class="col">
                                                    <spam style={{ color: "#36561e" }} > Profile8:&nbsp; </spam>
                                                    <spam style={{ color: "#77b935" }} >   {item.profile8} </spam>
                                                </div>
                                                <div class="col">
                                                    <spam style={{ color: "#36561e" }} >  Profile12:&nbsp; </spam>
                                                    <spam style={{ color: "#77b935" }} >   {item.profile12}</spam>
                                                </div>
                                                <div class="col">
                                                    <spam style={{ color: "#36561e" }} > Profile13:&nbsp; </spam>
                                                    <spam style={{ color: "#77b935" }} >   {item.profile13}</spam>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div class="col">
                                                    <spam style={{ color: "#36561e" }} >  DeliveryDay:&nbsp; </spam>
                                                    <spam style={{ color: "#77b935" }} >   {item.deliveryDay}</spam>
                                                </div>
                                                <div class="col" >
                                                </div>
                                                <div class="col">
                                                    <spam style={{ color: "#36561e" }} >  DeliveryDate01:&nbsp; </spam>
                                                    <spam style={{ color: "#77b935" }} >   {item.deliveryDate01}</spam>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div class="col">
                                                    <spam style={{ color: "#36561e" }} >   CutOffDate01:&nbsp; </spam>
                                                    <spam style={{ color: "#77b935" }} >   {item.cutOffDate01}</spam>
                                                </div>
                                                <div class="col" >
                                                </div>
                                                <div class="col">
                                                    <spam style={{ color: "#36561e" }} >  DeliveryDate01:&nbsp; </spam>
                                                    <spam style={{ color: "#77b935" }} >   {item.deliveryDate01}</spam>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div class="col">
                                                    <spam style={{ color: "#36561e" }} >  CutOffDate02:&nbsp; </spam>
                                                    <spam style={{ color: "#77b935" }} >   {item.cutOffDate02}</spam>
                                                </div>
                                                <div class="col" >
                                                </div>
                                                <div class="col">
                                                    <spam style={{ color: "#36561e" }} >  DeliveryDate02:&nbsp; </spam>
                                                    <spam style={{ color: "#77b935" }} >   {item.deliveryDate02}</spam>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div class="col">
                                                    <spam style={{ color: "#36561e" }} >   CutOffDate03:&nbsp; </spam>
                                                    <spam style={{ color: "#77b935" }} >   {item.cutOffDate03}</spam>
                                                </div>
                                                <div class="col" >
                                                </div>
                                                <div class="col">
                                                    <spam style={{ color: "#36561e" }} >   DeliveryDate03:&nbsp; </spam>
                                                    <spam style={{ color: "#77b935" }} >   {item.deliveryDate03}</spam>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div class="col">
                                                    <spam style={{ color: "#36561e" }} >  CreatedAtStaging:&nbsp; </spam>
                                                    <spam style={{ color: "#77b935" }} >   {item.createdAtStaging}</spam>
                                                </div>
                                                <div class="col" >
                                                </div>
                                                <div class="col">
                                                    <spam style={{ color: "#36561e" }} >  UpdatedAtStaging:&nbsp;</spam>
                                                    <spam style={{ color: "#77b935" }} >     {item.updatedAtStaging}</spam>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div class="col">
                                                    <spam style={{ color: "#36561e" }} >  SendToHybrisStatus:&nbsp; </spam>
                                                    <spam style={{ color: "#77b935" }} >   {item.sendToHybrisStatus}</spam>
                                                </div>
                                                <div class="col" >
                                                </div>
                                                <div class="col">
                                                    <spam style={{ color: "#36561e" }} >  SendDataHybris:&nbsp; </spam>
                                                    <spam style={{ color: "#77b935" }} >  {item.sendDataHybris}</spam>
                                                </div>
                                            </div>
                                        </div>
                                        // </tr>
                                    )
                                })
                            }

                        </div>

                    </Modal.Body>

                    <Modal.Footer>
                    </Modal.Footer>
                </Modal>

                {/*Modal leitura*/}
                <Modal size="sm" show={(this.state.isModalOpen === 5 ? true : false)}
                    className="modal fade" role="dialog"
                    onHide={this.closeModal}

                >
                    <Modal.Body >
                        <div className="row d-flex justify-content-center" >
                            <Spinner animation="border" role="status" variant="success">
                            </Spinner>
                        </div>
                        <div className="row" style={{ textAlign: "Center" }}>
                            <i className="fa-blink "> {this.state.MsgModal2}</i>
                            {/* <span> {this.state.MsgModal2} </span> */}

                        </div>
                    </Modal.Body>

                </Modal>

            </div >

        )
    }
}
const mapStateToProps = state => (
    {
        nomeUsuario: state.authRed.NomUsuario
        , codPuxada: state.authRed.CodPuxada
        , TipoLicenca: state.authRed.TipoUsuario
        , bsclistaTdsUF: state.customerRedJS.ListaTodosUF
        , bsclistaTdsUFCid: state.customerRedJS.ListaTodosUFCid
        , bsclistaTdsEnd: state.customerRedJS.ListaTodosEnd
        , bsclistaTdsVnd: state.customerRedJS.ListaTodosVnd
        , bsclistaTodosCet: state.customerRedJS.ListaTodosCet
        , redListaTdsRevendas: state.customerRedJS.ListaTdsRevendas
        , BscDelivery: state.customerRedJS.DadosDelivery
        , BscFinancial: state.customerRedJS.DadosFinancial
        , BscInformacoes: state.customerRedJS.DadosInformacoes

        , RefazCampo: state.customerRedJS.RecarregaInformacoes
    }
)
const mapDispatchToProps = dispatch => bindActionCreators(
    {
        logout
        , GetCustumerUF, GetCustumerUFCid, GetCustumerEnd, GetCustumerVnd
        , getDataTdsRevendas
        , GetCustumerTodosCet
        , getDataDelivery, getDataFinancial, enviaRegistros
        //, teste
        // , getDataInformacoes
    }
    , dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Customer)